"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationInvoiceListFilter = exports.reservationInvoiceListFilterConfig = exports.className = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const dateTime_1 = require("../../../../utils/dateTime");
const Button_1 = require("../../../Button");
const Multiple_1 = require("../../../CheckBox/Multiple");
const Field_1 = require("../../../Form/Field");
const stable_1 = require("../../../Form/Field/DateRange/stable");
const utils_1 = require("./utils");
require("./index.scss");
exports.className = 'reservation-invoice-list-filter';
const reservationInvoiceListFilterConfig = (value) => {
    var _a;
    return ({
        type: 'object',
        optional: true,
        shape: {
            query: {
                type: 'string',
                optional: true,
                modificators: 'search',
            },
            paymentStatus: {
                type: 'array',
                optional: true,
                items: [
                    'unpaid',
                ],
            },
            deadlineDateInterval: {
                type: 'object',
                optional: true,
                modificators: 'together',
                dateRestrictions: {
                    pastYearsCount: dateTime_1.bookingFilterPastYearsCount,
                    nextYearsCount: dateTime_1.bookingNextYearsCount,
                },
                shape: {
                    from: {
                        type: 'date',
                        optional: true,
                    },
                    to: {
                        type: 'date',
                        optional: true,
                        dateRestrictions: {
                            notAllowedBeforeDate: (_a = value === null || value === void 0 ? void 0 : value.deadlineDateInterval) === null || _a === void 0 ? void 0 : _a.from,
                        },
                    },
                },
            },
        },
    });
};
exports.reservationInvoiceListFilterConfig = reservationInvoiceListFilterConfig;
const ReservationInvoiceListFilter = (props) => {
    const { field, submit, } = props;
    const { formatMessage } = (0, react_intl_1.useIntl)();
    return (react_1.default.createElement("div", { className: exports.className },
        react_1.default.createElement("div", { className: `${exports.className}__form` },
            react_1.default.createElement(Field_1.FormFieldStable, { ...field(['query']), placeholder: formatMessage({
                    id: 'components/Reservation/List:searchPlaceholder',
                    defaultMessage: 'Search',
                }), additionClassNames: `${exports.className}__search`, prefixIcon: 'search' }),
            react_1.default.createElement(Button_1.Button, { text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List:SearchButton', defaultMessage: 'Search' }), modificators: ['ascetic', 'block'], onClick: submit, additionClassNames: `${exports.className}__button` }),
            react_1.default.createElement(Multiple_1.CheckBoxMultiple, { ...field(['paymentStatus']), toItem: utils_1.mapReservationPaymentStatusToItem }),
            react_1.default.createElement(stable_1.FormFieldDateRangeStable, { ...field(['deadlineDateInterval']), additionClassNames: `${exports.className}__range-dates`, fromField: {
                    ...field(['deadlineDateInterval', 'from']),
                    label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/InvoiceOverview:DeadlineFrom', defaultMessage: 'Deadline from' })),
                }, toField: {
                    ...field(['deadlineDateInterval', 'to']),
                    label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/InvoiceOverview:DeadlineTo', defaultMessage: 'To' })),
                } }))));
};
exports.ReservationInvoiceListFilter = ReservationInvoiceListFilter;
//# sourceMappingURL=index.js.map